import {SCHEDULE_STATUS_CODES} from "./schedule.constants.js";

export const SORT_BY = {
    PERSON: {
        ID: 'PERSON',
        LABEL: $filter("translate")("Person"),
    },
    ROLE: {
        ID: 'ROLE',
        LABEL: $filter("translate")("Position"),
    },
    ROLE_PERSON: {
        ID: 'ROLE_PERSON',
        LABEL: $filter("translate")("Position then person"),
    },
    CATEGORY_PERSON: {
        ID: 'CATEGORY_PERSON',
        LABEL: $filter("translate")("Category then person"),
    },
};

export const PUBLISH_STATUSES_TYPES = {
    [SCHEDULE_STATUS_CODES.PUBLISHED]: {
        id: SCHEDULE_STATUS_CODES.PUBLISHED,
        name: SCHEDULE_STATUS_CODES.PUBLISHED,
        label: $filter('translate')('Published shifts'),
    },
    [SCHEDULE_STATUS_CODES.UNPUBLISHED]: {
        id: SCHEDULE_STATUS_CODES.UNPUBLISHED,
        name: SCHEDULE_STATUS_CODES.UNPUBLISHED,
        label: $filter('translate')('Unpublished shifts'),
    }
}

export const SCHEDULE_VIEWS_CODES = {
    MONTHLY: 'MONTHLY',
    WEEKLY: 'WEEKLY',
    DAILY: 'DAILY',
    SCHEDULED_BREAKS: 'SCHEDULED_BREAKS',
}

export const SCHEDULE_VIEWS = {
    MONTHLY: {
        id: SCHEDULE_VIEWS_CODES.MONTHLY,
        label: $filter("translate")("Monthly schedule"),
        dataDogActionName: 'view-monthly-schedule',
        automation: 'ScheduleViewMonthView',
    },
    WEEKLY: {
        id: SCHEDULE_VIEWS_CODES.WEEKLY,
        label: $filter("translate")("Weekly schedule"),
        dataDogActionName: 'view-weekly-schedule',
        automation: 'ScheduleViewWeekView',
    },
    DAILY: {
        id: SCHEDULE_VIEWS_CODES.DAILY,
        label: $filter("translate")("Daily schedule"),
        automation: 'ScheduleViewDayView',
        dataDogActionName: 'view-daily-schedule',
    },
    SCHEDULED_BREAKS: {
        id: SCHEDULE_VIEWS_CODES.SCHEDULED_BREAKS,
        label: $filter("translate")("Scheduled breaks"),
        automation: 'ScheduleViewScheduledBreaks',
    },
};

export const MONTHLY_WEEKS_COUNT_CODES = {
    FOUR: 'FOUR',
    SIX: 'SIX',
    FIVE: 'FIVE',
}

export const MONTHLY_WEEKS_COUNTS_CONFIG = {
    FOUR: {
        id: MONTHLY_WEEKS_COUNT_CODES.FOUR,
        label: $filter('translate')('4 weeks'),
        value: 4,
    },
    FIVE: {
        id: MONTHLY_WEEKS_COUNT_CODES.FIVE,
        label: $filter('translate')('5 weeks'),
        value: 5,
    },
    SIX: {
        id: MONTHLY_WEEKS_COUNT_CODES.SIX,
        label: $filter('translate')('6 weeks'),
        value: 6,
    }
}

export const SCHEDULE_SIDEBAR_PANELS = {
    EMPLOYEE_SUMMARY: {
        id: 'EMPLOYEE_SUMMARY',
        label: $filter('translate')('Employee summary')
    },
    RUN_SHIFT_DETAILS: {
        id: 'RUN_SHIFT_DETAILS',
        label: $filter('translate')('Manager running the shifts')
    },
}

export const EMPLOYEE_SUMMARY_OPTIONS = {
    NAME: {
        id: 'NAME',
        label: $filter('translate')('Name'),
    },
    TOTAL_HOURS: {
        id: 'TOTAL_HOURS',
        label: $filter('translate')('Total hours'),
    },
    CONSECUTIVE_DAYS: {
        id: 'CONSECUTIVE_DAYS',
        label: $filter('translate')('Consecutive days'),
    },
    DAYS_OFF: {
        id: 'DAYS_OFF',
        label: $filter('translate')('Days off'),
    }
}